<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 顶部 Tab + 操作 -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px">
        <el-radio-group v-model="currentType" size="small" @change="fetchList">
          <el-radio-button :label="1">固定资产</el-radio-button>
          <el-radio-button :label="2">易耗品</el-radio-button>
        </el-radio-group>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd(null)">新增类别</el-button>
      </div>
      <!-- 类别树形表格 -->
      <el-table :data="tableData" row-key="id" border :tree-props="{ children: 'children' }" default-expand-all
        v-loading="loading">
        <el-table-column prop="typeName" label="类别名称" min-width="220" show-overflow-tooltip>
          <template #default="{ row }">
            <i class="el-icon-folder" style="margin-right: 5px; color: #909399"></i>
            {{ row.typeName }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码" align="center" width="120" show-overflow-tooltip />
        <el-table-column prop="sort" label="排序" align="center" width="80" />
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="160" />
        <el-table-column label="操作" align="center" width="300" fixed="right">
          <template #default="{ row }">
            <el-button v-if="row._level < 2" type="text" size="mini" icon="el-icon-plus"
              @click="handleAdd(row)">添加子级</el-button>
            <el-button v-if="row._level >= 2" v-permission="'school:asset:allocateType'" type="text" size="mini"
              icon="el-icon-sort" @click="handleAllocate(row)">调配至新类别</el-button>
            <el-button type="text" size="mini" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c"
              @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="typeForm" label-width="80px">
        <el-form-item label="类别名称" prop="typeName">
          <el-input v-model="form.typeName" placeholder="请输入类别名称" maxlength="50" show-word-limit
            :disabled="!!form.id" />
        </el-form-item>
        <el-form-item v-if="form.parentId === 0" label="编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入编码" maxlength="50" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 调配至新类别弹窗 -->
    <el-dialog title="调配至新类别" :visible.sync="allocateDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item label="当前类别">
          <span>{{ allocateRow ? allocateRow.typeName : '' }}</span>
        </el-form-item>
        <el-form-item label="目标类别">
          <el-cascader v-model="allocateNewTypeId" :options="tableData"
            :props="{ value: 'id', label: 'typeName', children: 'children', emitPath: false }" placeholder="请选择新类别"
            clearable filterable class="ele-fluid" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="allocateDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="allocateLoading" @click="submitAllocate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { typeList, saveType, deleteType, allocateType } from '@/config/assetApi';

export default {
  name: 'AssetType',
  data () {
    return {
      currentType: 1,
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增类别',
      submitLoading: false,
      form: {
        id: null,
        typeName: '',
        code: '',
        type: 1,
        parentId: null,
        sort: 0,
        status: 1,
      },
      rules: {
        typeName: [{ required: true, message: '请输入类别名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
      },
      // 调配
      allocateDialogVisible: false,
      allocateLoading: false,
      allocateRow: null,
      allocateNewTypeId: '',
    };
  },
  created () {
    this.fetchList();
  },
  methods: {
    markLevel (list, level) {
      return list.map((item) => {
        item._level = level;
        if (item.children && item.children.length) {
          item.children = this.markLevel(item.children, level + 1);
        }
        return item;
      });
    },
    fetchList () {
      this.loading = true;
      typeList({ type: this.currentType })
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.tableData = this.markLevel(res.data.data || [], 1);
          } else {
            this.tableData = [];
          }
        })
        .catch(() => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAdd (parentData) {
      this.dialogTitle = parentData ? `在"${parentData.typeName}"下新增` : '新增类别';
      this.form = {
        id: null,
        typeName: '',
        code: '',
        type: this.currentType,
        parentId: parentData ? parentData.id : 0,
        sort: 0,
        status: 1,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.typeForm && this.$refs.typeForm.clearValidate();
      });
    },
    handleEdit (data) {
      this.dialogTitle = '编辑类别';
      this.form = {
        id: data.id,
        typeName: data.typeName,
        code: data.code,
        type: data.type,
        parentId: data.parentId,
        sort: data.sort,
        status: data.status,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.typeForm && this.$refs.typeForm.clearValidate();
      });
    },
    handleDelete (data) {
      this.$confirm(`确定要删除类别"${data.typeName}"吗？`, '提示', {
        type: 'warning',
      })
        .then(() => {
          let formData = new FormData();
          formData.append('id', data.id);
          deleteType(formData).then((res) => {
            if (res.data && res.data.resCode == 200) {
              this.$message.success('删除成功');
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.resMsg) || '删除失败');
            }
          });
        })
        .catch(() => { });
    },
    handleAllocate (row) {
      this.allocateRow = row;
      this.allocateNewTypeId = '';
      this.allocateDialogVisible = true;
    },
    submitAllocate () {
      if (!this.allocateNewTypeId) {
        this.$message.warning('请选择目标类别');
        return;
      }
      if (this.allocateNewTypeId === this.allocateRow.id) {
        this.$message.warning('不能调配到自身类别');
        return;
      }
      this.allocateLoading = true;
      let formData = new FormData();
      formData.append('id', this.allocateRow.id);
      formData.append('newTypeId', this.allocateNewTypeId);
      allocateType(formData)
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.$message.success('调配成功');
            this.allocateDialogVisible = false;
            this.fetchList();
          } else {
            this.$message.error((res.data && res.data.resMsg) || '调配失败');
          }
        })
        .finally(() => {
          this.allocateLoading = false;
        });
    },
    handleSubmit () {
      this.$refs.typeForm.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let formData = new FormData();
        for (let key in this.form) {
          if (this.form[key] !== null && this.form[key] !== undefined && this.form[key] !== '') {
            formData.append(key, this.form[key]);
          }
        }
        saveType(formData)
          .then((res) => {
            if (res.data && res.data.resCode == 200) {
              this.$message.success('保存成功');
              this.dialogVisible = false;
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.resMsg) || '保存失败');
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped></style>
